import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import Calendar from "../../../../../../components/calendar/Calendar";
import Input from "../../../../../../components/textbox/Input";
import Autocomplete from '../../../../../../components/autocomplete/Autocomplete';
import OggettiUtili from "../../../../../../utils/OggettiUtili.json";
import Utils from "../../../../../../utils/Utils";
import SelectAutocomplete from "../../../../../../components/selectAutocomplete/SelectAutocomplete";
import SessioneUtente from "../../../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../../../utils/Ruoli";

class DatiCompilatore extends Component {

    state = {
        datiCompilatore: {
            dataSegnalazione: "",
            regione: OggettiUtili.Regioni["050"],
            ulss: "",
            nome: "",
            cognome: "",
            telefonoFisso: "",
            telefonoCellulare: "",
            email: "",
            corretto: []
        },
        regioni: OggettiUtili.Regioni

    }

    constructor(props) {
        super(props);
        this.riceviValoreInput = this.riceviValoreInput.bind(this);
        this.createJsonForBackend = this.createJsonForBackend.bind(this)
        this.validate = this.validate.bind(this);
    }

    componentDidMount() {
        let datiCompilatore = this.state.datiCompilatore
        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.datiCompilatore) {
            let propsCompilatore = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.schedaSpeciale.datiCompilatore))
            datiCompilatore.nome = propsCompilatore.nome ? propsCompilatore.nome : ""
            datiCompilatore.cognome = propsCompilatore.cognome ? propsCompilatore.cognome : ""
            datiCompilatore.telefonoFisso = propsCompilatore.telefonoFisso ? propsCompilatore.telefonoFisso : ""
            datiCompilatore.telefonoCellulare = propsCompilatore.telefonoCellulare ? propsCompilatore.telefonoCellulare : ""
            datiCompilatore.email = propsCompilatore.email ? propsCompilatore.email : ""
            datiCompilatore.dataSegnalazione = propsCompilatore.dataSegnalazione ? propsCompilatore.dataSegnalazione : Utils.formatDateISO(this.props.segnalazioneCopia?.dataSegnalazione, "/")
            if (propsCompilatore.regione && propsCompilatore.regione.length===2){
                propsCompilatore.regione=propsCompilatore.regione.concat("0")
            }
            datiCompilatore.regione = propsCompilatore.regione ? OggettiUtili.Regioni[propsCompilatore.regione] : ""
            datiCompilatore.ulss = propsCompilatore ? OggettiUtili.ulssMap[propsCompilatore.ulss].codice : ""
            this.setState({datiCompilatore: datiCompilatore})
        } else {
            datiCompilatore.dataSegnalazione = Utils.formatDateISO(this.props.segnalazioneCopia?.dataSegnalazione, "/")
            datiCompilatore.ulss = this.props.segnalazioneCopia.ulssSegnalazione
            this.setState({datiCompilatore: datiCompilatore})
        }

        this.props.setDatiCompilatore(this.state.datiCompilatore)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState !== this.state) {
            let res = this.createJsonForBackend();
            this.props.setDatiCompilatore(this.state.datiCompilatore, this.validate(), res)
        }
    }

    validate() {

        if (this.state.datiCompilatore.dataSegnalazione) {
            let validatedataSegnalazione = Utils.checkDateInterval(this.state.datiCompilatore.dataSegnalazione, "31/12/1899");
            let validatedataSegnalazioneOdierna = Utils.checkDateInterval(this.state.datiCompilatore.dataSegnalazione, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataSegnalazione) {
                return "Messages.DataSegnalazione"
            } else if (!validatedataSegnalazioneOdierna) {
                return "Messages.DataSegnalazioneOdierna"
            }
        }

        return ""

    }

    createJsonForBackend() {
        let dati = this.state.datiCompilatore
        let ObjectForBackEnd = {}
        ObjectForBackEnd["dataSegnalazione"] = dati.dataSegnalazione
        if (dati.regione && dati.regione.codice) {
            ObjectForBackEnd["regione"] = dati.regione.codice
        } else
            ObjectForBackEnd["regione"] = this.state.regioni
        if (dati.ulss) {
            ObjectForBackEnd["ulss"] = dati.ulss
        } else
            ObjectForBackEnd["regione"] = this.props.segnalazioneCopia.ulssSegnalazione
        ObjectForBackEnd["nome"] = dati.nome
        ObjectForBackEnd["cognome"] = dati.cognome
        ObjectForBackEnd["telefonoFisso"] = dati.telefonoFisso
        ObjectForBackEnd["telefonoCellulare"] = dati.telefonoCellulare
        ObjectForBackEnd["email"] = dati.email


        let res = Utils.removeEmptyValueFromObject(ObjectForBackEnd);
        return res;

    }

    riceviValoreInput(field, event) {

        let datiCompilatore = this.state.datiCompilatore
        if (field.currentTarget) {
            datiCompilatore[field.currentTarget.id] = field.currentTarget.value
        } else {
            datiCompilatore[field] = event.target.value
        }
        this.setState({datiCompilatore: datiCompilatore})
    }


    render() {

        const {t} = this.props
        let arrayUlss = [];
        Object.keys(OggettiUtili.ulssMap).map((key) => {
            arrayUlss.push(OggettiUtili.ulssMap[key]);
        });

        return (<div>
            <div>
                <h6>{t("SchedaInfluenzaGrave.datiCompilatore")}</h6>
                <hr className={styles.hr}/>
            </div>
            <div className={"container"}>

                <div className="row" style={{marginTop: "10px", height: "60px"}}>
                    <div className="col-lg-5">
                        <div className="row">
                            <div className="col-lg-6" style={{marginTop: "10px"}}>
                                <p className={styles.labelHeader}>
                                    <b>{t("SchedaInfluenzaGrave.dataSegnalazione")}</b>

                                </p>
                            </div>
                            <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>

                                <Calendar
                                    id="dataSegnalazione"
                                    field={"dataSegnalazione"}
                                    value={this.state.datiCompilatore.dataSegnalazione}
                                    onChange={this.riceviValoreInput}
                                    errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                        "Data")}
                                    error={(this.state.datiCompilatore.dataSegnalazione === "" ||
                                        this.state.datiCompilatore.dataSegnalazione == null) ? false :
                                        Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiCompilatore.dataSegnalazione), "-")}
                                >
                                </Calendar>

                            </div>
                        </div>
                    </div>
                    <div className="col-lg-1"/>
                    <div className="col-lg-5">
                        <div className="row">
                            <div className="col-lg-6" style={{marginTop: "10px"}}>
                                <p className={styles.labelHeader}>
                                    <b>{t("SchedaInfluenzaGrave.regione")}</b>

                                </p>
                            </div>
                            <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                <div className={styles.fieldContainer}>
                                    <Autocomplete
                                        id="regione"
                                        onChange={this.riceviValoreInput}
                                        field={"regione"}
                                        keyField={"codice"}
                                        descriptionField={"descrizione"}
                                        disabled={true}
                                        suggestionField={"descrizione"}
                                        value={this.state.datiCompilatore.regione}
                                        suggestions={this.state.regioni}
                                    >
                                    </Autocomplete>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row" style={{marginTop: "10px", height: "60px"}}>
                    <div className="col-lg-5">
                        <div className="row">
                            <div className="col-lg-6" style={{marginTop: "10px"}}>
                                <p className={styles.labelHeader}>
                                    <b>{t("SchedaInfluenzaGrave.ulss")}</b>
                                </p>
                            </div>
                            <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                <div className={styles.fieldContainer}>
                                    <SelectAutocomplete
                                        id={"ulss"}
                                        field={"ulss"}
                                        value={this.state.datiCompilatore.ulss}
                                        onChange={this.riceviValoreInput}
                                        disabled={SessioneUtente.getInstance().ruoliUtente !== Ruoli.Operatore_Regionale.descrizione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                            this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)}
                                        functionMap={arrayUlss.map((oggetto) => {
                                            return (
                                                <option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                        })}
                                    >
                                    </SelectAutocomplete>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-1"/>
                    <div className="col-lg-5">
                        <div className="row">
                            <div className="col-lg-6" style={{marginTop: "10px"}}>
                                <p className={styles.labelHeader}>
                                    <b>{t("SchedaInfluenzaGrave.nome")}</b>

                                </p>
                            </div>
                            <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>

                                <Input
                                    id="nome"
                                    field={"nome"}
                                    value={this.state.datiCompilatore.nome}
                                    placeholder={"Nome"}
                                    onChange={this.riceviValoreInput}
                                >
                                </Input>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="row" style={{marginTop: "10px", height: "60px"}}>
                    <div className="col-lg-5">
                        <div className="row">
                            <div className="col-lg-6" style={{marginTop: "10px"}}>
                                <p className={styles.labelHeader}>
                                    <b>{t("SchedaInfluenzaGrave.cognome")}</b>

                                </p>
                            </div>
                            <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>

                                <Input
                                    id="cognome"
                                    field={"cognome"}
                                    value={this.state.datiCompilatore.cognome}
                                    placeholder={"Cognome"}
                                    onChange={this.riceviValoreInput}
                                >
                                </Input>

                            </div>
                        </div>
                    </div>
                    <div className="col-lg-1"/>
                    <div className="col-lg-5">
                        <div className="row">
                            <div className="col-lg-6" style={{marginTop: "10px"}}>
                                <p className={styles.labelHeader}>
                                    <b>{t("SchedaInfluenzaGrave.telefonoFisso")}</b>

                                </p>
                            </div>
                            <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>

                                <Input
                                    id="telefonoFisso"
                                    field={"telefonoFisso"}
                                    value={this.state.datiCompilatore.telefonoFisso}
                                    placeholder={"Telefono fisso"}
                                    onChange={this.riceviValoreInput}
                                >
                                </Input>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="row" style={{marginTop: "10px", height: "60px"}}>
                    <div className="col-lg-5">
                        <div className="row">
                            <div className="col-lg-6" style={{marginTop: "10px"}}>
                                <p className={styles.labelHeader}>
                                    <b>{t("SchedaInfluenzaGrave.telefonoCellulare")}</b>
                                </p>
                            </div>
                            <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>

                                <Input
                                    id="telefonoCellulare"
                                    field={"telefonoCellulare"}
                                    value={this.state.datiCompilatore.telefonoCellulare}
                                    placeholder={"Telefono cellulare"}
                                    onChange={this.riceviValoreInput}
                                >
                                </Input>

                            </div>
                        </div>
                    </div>
                    <div className="col-lg-1"/>
                    <div className="col-lg-5">
                        <div className="row">
                            <div className="col-lg-6" style={{marginTop: "10px"}}>
                                <p className={styles.labelHeader}>
                                    <b>{t("SchedaInfluenzaGrave.email")}</b>
                                </p>
                            </div>
                            <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>

                                <Input
                                    id="email"
                                    field={"email"}
                                    value={this.state.datiCompilatore.email}
                                    placeholder={"Email"}
                                    onChange={this.riceviValoreInput}
                                >
                                </Input>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>)
    }


}


export default withTranslation('common')(DatiCompilatore)
